import React, { CSSProperties } from 'react';
import { Typography } from 'antd';

interface TitleProps {
  children?: React.ReactNode;
}

export const titleStyle: CSSProperties = {
  padding: 5,
  fontWeight: 230,
  fontSize: 22,
  lineHeight: '27px',
  fontFamily: 'Open Sans, sans-serif',
  color: '#000000',
  display: 'flex',
  alignItems: 'center',
  letterSpacing: '0.03em',
  margin: '0 0 0.25rem 0',
};

export const Title: React.FC<TitleProps> = ({ children }) => {
  return (
    <Typography.Title level={3} style={titleStyle}>
      {children}
    </Typography.Title>
  );
};
